module.exports = __webpack_public_path__ + "static/media/icons8-lock.59f861dd.svg";